import { Card } from "react-bootstrap";
import { APIURL } from "../resources/fetch";

const PublicEventLayout = ({ event, children }) => (
    <main className="public-event-page py-4 py-md-5 px-2">
        <div className="public-event-container">
            <div className="text-center mb-4">
                <div className="public-event-logos mb-3">
                    {event?.client_logo_file_id && <img src={`${APIURL}/files/${event.client_logo_file_id}/view/image`} alt={`${event.title || "Client"} logo`} />}
                    <img src="/logo/logo.png" alt="The Soundz" />
                </div>
                {event && <>
                    <h1 className="h3 mb-2">{event.title}</h1>
                    <div className="text-muted">
                        {event.location && <span><i className="fas fa-location-dot me-1" />{event.location}</span>}
                        {event.location && event.start_date && <span className="mx-2">•</span>}
                        {event.start_date && <span><i className="far fa-calendar me-1" />{event.start_date}</span>}
                    </div>
                </>}
            </div>
            <Card className="border-0 shadow-sm"><Card.Body className="p-3 p-md-4">{children}</Card.Body></Card>
            <p className="small text-center text-muted mt-4 mb-0">Event registration and feedback</p>
        </div>
    </main>
);

export default PublicEventLayout;
